import Logo from "../../components/items/Logo"
import { motion } from "framer-motion";
import AppContext from "../../context/AppContext";
import { useState, useRef, useContext } from "react"

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState('')
  const emailRef = useRef()
  const { goHome } = useContext(AppContext)

  const isEmail = (value) => {
    // Regular expression for a basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    // Test the value against the regex
    return emailRegex.test(value);
  }

  const onSubmit = (e) => {
    e.preventDefault();
    setEmailErr('')
    emailRef.current.classList.remove('err')

    if(!email){
      setEmailErr("Please enter your email")
      emailRef.current.classList.add('err')
    }

    if(!isEmail(email) && email){
      setEmailErr("Please enter a valid email")
      emailRef.current.classList.add('err')
    }
    console.log({
      email
    })
    // setEmail('');
  }

  return (
    <motion.main 
      className="user-form" 
      id="forgot_password"
      initial={{width: 0}}
      animate={{width: '100%'}}
      exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
      <div className='medbolt-logo' onClick={goHome}>
          <Logo/>
      </div>
      <h1>Forgot Password</h1>
      <form noValidate onSubmit={onSubmit} className="forgot_password">
          <p>
            We will email you instructions on how to reset your password
          </p>
          <div className="user-input">
            <input ref={emailRef} type="email" value={email} required placeholder="email@gmail.com" onChange={(e) => setEmail(e.target.value)} style={{marginBottom : !emailErr && "3rem"}}/>
            {emailErr && <div className="error">{emailErr}</div>}
          </div>
          <button type="submit" className="trynow">Submit</button>
          <p className="resend">Can’t find the email, <span className="link">click here to resend mail</span></p>
      </form>

    </motion.main>
  )
}

export default ForgotPassword